import { render, staticRenderFns } from "./estados_de_domicilios.vue?vue&type=template&id=ca69fae6&"
import script from "./estados_de_domicilios.vue?vue&type=script&lang=js&"
export * from "./estados_de_domicilios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports